import { baseApiWithCompanyId } from 'src/redux/services/baseApi';
import { Plan } from 'src/dto/Credits';
import { ScoreRequest } from './dto/scoreRequest';

export interface ActivePlansResponse {
  filters: {
    company_id: string;
  };
  items: Plan[];
  total: number;
}

const plansApi = baseApiWithCompanyId.injectEndpoints({
  endpoints: (builder) => ({
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    getPlans: builder.query<ActivePlansResponse, void>({
      query: () => ({
        url: `v1/admin/plans/active`,
      }),
      providesTags: ['Plans'],
    }),
    updatePlans: builder.mutation<ScoreRequest, ScoreRequest>({
      query(data) {
        return {
          url: 'v1/admin/plans/upsert',
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: ['Plans'],
    }),
  }),
});

export const { useGetPlansQuery, useUpdatePlansMutation } = plansApi;
